
// document.querySelectorAll('.zpro-bundle-summary-wraps').forEach((el, i) => i < 3 && document.querySelector('.bbt-details').insertAdjacentHTML('beforeend', el.innerHTML));

//above is temperery

// Call the function on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleSliders);
} else {
    initBundleSliders();
}

setTimeout(updateBundleCardQty, 1000);


//run this after each ajax product call and add item
function initBundleSliders() {
    // Select all elements with the class 'jspcimg-slider'
    var sliders = document.querySelectorAll('.bundimg-slider');
    sliders.forEach(function(slider) {
        // Check if Flickity is available and slider not already initialized
        if (typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
            // Initialize Flickity slider
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                imagesLoaded: true,
                wrapAround: true
            });
            // Remove the class to prevent re-initialization
            slider.classList.remove('bundimg-slider');
        }
    });
}

function updateBundleCardQty()
{

    // Get all elements with data-bb-added-id inside #bbt-added-items
    const addedItems = document.querySelectorAll('#bbt-added-items [data-bb-added-id]');
    // Loop through each added item
    for (let i = 0; i < addedItems.length; i++) {
        const item = addedItems[i];
        if (!item) continue;

        // Get the variant ID from data-bb-added-id
        const variantId = item.getAttribute('data-bb-added-id');

        // Get the quantity from data-bb-added-qty
        const quantity = item.getAttribute('data-bb-added-qty');

        if (!variantId) continue;

        // Find the matching element in .fsb-products with the same variant ID
        const matchingElement = document.querySelector(`.fsb-products [data-bbvariant-id="${variantId}"].bbadd-var`);

        if (matchingElement) {
            // Add 'selected' class to the matching element
            matchingElement.classList.add('selected');

            // INSERT_YOUR_CODE
            if (quantity == 0) {
                matchingElement.classList.remove('selected');
            }


            // Find the quantity input child and update its value
            const quantityInput = matchingElement.querySelector('.quantity__input');
            if (quantityInput && quantityInput instanceof HTMLInputElement) {
                quantityInput.value = quantity || '0';
            }
        }
    }
}


//all click events
document.addEventListener('click', function (event) {
    //bb pagination click ajax call
    const clickedLink = event.target.closest('a.bb-next');
    if(clickedLink)
    {
        const newUrl = clickedLink.href;
        event.preventDefault();
        clickedLink.textContent = 'LOADING...';

        // Fetch content from the new URL
        const mainurl = newUrl.toString().split("?")[0];
        const requestUrl = `${newUrl}&section_id=zpro-bundle-collection-s`;
        console.log(requestUrl);
        fetch(requestUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(html => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;

                const newProducts = tempDiv.querySelector('.fsb-products');
                if (newProducts) {
                    const currentProducts = document.querySelector('.fsb-products');
                    if (currentProducts) {
                        currentProducts.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                    }
                }

                const newPagination = tempDiv.querySelector('.jl-pagination');
                if (newPagination) {
                    const currentPagination = document.querySelector('.jl-pagination');
                    if (currentPagination) {
                        currentPagination.innerHTML = newPagination.innerHTML;
                    }
                }
                initBundleSliders();
                updateBundleCardQty();
            })
            .catch(error => {
                console.error('Error loading content:', error);
            });
    }

    //BB filter collection click
    const bundleFilterLink = event.target.closest('.bundle-filter-link');
    if (bundleFilterLink) {
        event.preventDefault();
        const bundleFilters = bundleFilterLink.closest('.bundle-filters');
        if (bundleFilters) {
            bundleFilters.querySelectorAll('.bundle-filter-link').forEach(link => {
                link.classList.remove('active');
            });
            bundleFilterLink.classList.add('active');
            fetchBundleCollection(bundleFilterLink.href);
        }
    }



    //when click bb cards swatch
    const bbvThumb = event.target.closest('.bbv-thumb');
    if (bbvThumb) {
        event.preventDefault();
        const variantId = bbvThumb.getAttribute('data-bbvariant-id');
        const parentItem = bbvThumb.closest('.jlc-item');
        const bbCard = bbvThumb.closest('.bb-card');

        if (parentItem && variantId) {
            // Remove active class from all variant elements
            parentItem.querySelectorAll('[data-bbvariant-id]').forEach(el => {
                el.classList.remove('active');
            });

            // Add active class to matching variant elements
            parentItem.querySelectorAll(`[data-bbvariant-id="${variantId}"]`).forEach(el => {
                el.classList.add('active');
            });
        }

        // Update main image using data-car-image (same as collection page v-thumb)
        const carImage = bbvThumb.getAttribute('data-car-image');
        if (carImage && bbCard) {
            const firstImage = bbCard.querySelector('img.first-image');
            if (firstImage) {
                firstImage.setAttribute('src', carImage);
                firstImage.removeAttribute('srcset');
            }
        }
    }

    //when click select in bb card
    const addStyleButton = event.target.closest('.jspc-add-style');
    if (addStyleButton) {
        const parentVar = addStyleButton.closest('.bbadd-var');
        if (parentVar) {
            const qtyInput = parentVar.querySelector('.qty-input');
            if (qtyInput) {
                qtyInput.value = '1';
                qtyInput.dispatchEvent(new Event('change', {bubbles: true}));
            }
        }
    }

    //handle quantity change buttons
    const qtyButton = event.target.closest('[data-bbqty-change]');
    if (qtyButton) {
        event.preventDefault();
        const action = qtyButton.getAttribute('data-bbqty-change');
        const inputElement = qtyButton.parentElement.querySelector('input');
        if (inputElement) {
            let currentValue = parseInt(inputElement.value) || 0;
            if (action === 'dec') {
                currentValue = Math.max(0, currentValue - 1);
            } else if (action === 'inc') {
                currentValue += 1;
            }
            inputElement.value = currentValue;
            inputElement.dispatchEvent(new Event('change', {bubbles: true}));
        }
    }

    // Handle remove button in bundle summary row
    if (event.target && typeof event.target.closest === 'function') {
        const removeBtn = event.target.closest('.bbsr-remove');
        if (removeBtn) {
            event.preventDefault();
            const summaryRow = removeBtn.closest('.zpro-bundle-summary-row');
            if (summaryRow) {
                const id = summaryRow.getAttribute('data-bb-added-id');
                if (id) {
                    updateBBitems(id, 0);
                }
            }
        }
    }
    // Handle checkout button click
    const checkoutBtn = event.target.closest('.bb-checkout-btn');
    if (checkoutBtn) {
        event.preventDefault();
        if (typeof runBBCheckout === 'function') {
            runBBCheckout();
        }
    }
// Handle checkout button click
    const openBtn = event.target.closest('.bbt-title');
    if (openBtn) {
        event.preventDefault();
        const bundleWrapper = document.querySelector('.bundle-collection-wrapper');
        if (bundleWrapper) {
            bundleWrapper.classList.toggle('bbopen');
        }

    }


});

/**
 * Discount tier for the current bundle quantity.
 * data-bb-tier-n: 1st Discount tier block = 1 item, 2nd = 2 items, … 6th = 6 items + free gift.
 * (Theme "Items required" defaults to 3 on every block — we use tier order so 0/5/5/20/20/20 + gift maps correctly.)
 * Highest qualifying tier wins.
 */
function getQualifyingBundleTierBox(itemCount) {
    const wrap = document.querySelector('.bbt-boxes');
    if (!wrap || itemCount <= 0) return null;
    const tierBoxes = wrap.querySelectorAll('.bbt-box:not(.duplicated)');
    if (tierBoxes.length === 0) return null;
    let bestBox = null;
    let bestRequired = -1;
    for (let i = 0; i < tierBoxes.length; i++) {
        const box = tierBoxes[i];
        const tierN = parseInt(box.getAttribute('data-bb-tier-n'), 10);
        const req =
            Number.isFinite(tierN) && tierN > 0 ? tierN : i + 1;
        if (itemCount >= req && req >= bestRequired) {
            bestRequired = req;
            bestBox = box;
        }
    }
    return bestBox;
}

/** data-bb-d-code: missing, empty, or whitespace-only → do not append ?discount= at checkout */
function bbNormalizeDiscountCode(value) {
    if (value == null) return null;
    const t = String(value).trim();
    return t === '' ? null : t;
}

function runBBCheckout()
{
    // Disable checkout button(s) by adding inactive class
    const checkoutButtons = document.querySelectorAll('.bb-checkout-btn');
    checkoutButtons.forEach(btn => {
        btn.classList.add('inactive');
    });

    // Helper function to re-enable buttons
    const enableButtons = () => {
        checkoutButtons.forEach(btn => {
            btn.classList.remove('inactive');
        });
    };

    /** Set only when /cart/add.js is about to run; used for discount tier after async chain */
    let checkoutBundleItemCount = 0;

    // First, clear the cart
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to clear cart');
        }
        return response.json();
    })
    .then(() => {
        // Get all items from #bbt-added-items with data-bb-added-id
        const addedItems = document.querySelectorAll('#bbt-added-items [data-bb-added-id]');

        if (addedItems.length === 0) {
            console.warn('No items found in bundle builder');
            enableButtons();
            return;
        }

        // Calculate total item count
        let itemCount = 0;
        for (let i = 0; i < addedItems.length; i++) {
            const item = addedItems[i];
            const quantity = parseInt(item.getAttribute('data-bb-added-qty')) || 0;
            itemCount += quantity;
        }

        // Prepare items array for batch add
        const itemsToAdd = [];

        for (let i = 0; i < addedItems.length; i++) {
            const item = addedItems[i];
            const variantId = item.getAttribute('data-bb-added-id');
            const quantity = parseInt(item.getAttribute('data-bb-added-qty')) || 1;

            if (variantId && quantity > 0) {
                itemsToAdd.push({
                    id: variantId,
                    quantity: quantity,
                    properties: {
                        'Special': 'Bundle Builder'
                    }
                });
            }
        }

        if (itemsToAdd.length === 0) {
            console.warn('No valid items to add to cart');
            enableButtons();
            return;
        }

        // Free gift: same tier as discount — highest qualifying items_required threshold passed
        const qualifyingTier = getQualifyingBundleTierBox(itemCount);
        let freeGiftVariantId = qualifyingTier
            ? qualifyingTier.getAttribute('data-bb-free-gift')
            : null;

        // If free gift is eligible, add it to items array
        if (freeGiftVariantId) {
            itemsToAdd.push({
                id: freeGiftVariantId,
                quantity: 1,
                properties: {
                    'Special': 'Bundle Builder',
                    '_free_gift': 'true'
                }
            });
        }

        checkoutBundleItemCount = itemCount;

        // Add all items to cart (with or without free gift)
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: itemsToAdd })
        });
    })
    .then(response => {
        if (!response) {
            enableButtons();
            return;
        }
        if (!response.ok) {
            throw new Error('Failed to add items to cart');
        }
        return response.json();
    })
    .then(() => {
        // Redirect: only append discount when this tier has a non-empty data-bb-d-code
        const qualifyingForCheckout = getQualifyingBundleTierBox(checkoutBundleItemCount);
        const discountForCheckout = qualifyingForCheckout
            ? bbNormalizeDiscountCode(qualifyingForCheckout.getAttribute('data-bb-d-code'))
            : null;
        let checkoutUrl = '/checkout';
        if (discountForCheckout) {
            checkoutUrl += '?discount=' + encodeURIComponent(discountForCheckout);
        }
        window.location.href = checkoutUrl;
        // Note: We don't remove inactive class here since we're redirecting
    })
    .catch(error => {
        console.error('Error during checkout process:', error);
        enableButtons();
        alert('There was an error processing your checkout. Please try again.');
    });
}

//handle input changes for dynamically loaded content
document.addEventListener('change', function (event) {
    const ChangedItem = event.target;

    if (ChangedItem.classList.contains('bbtcard-qty')) {
            const variantId = ChangedItem.getAttribute('data-bb-varid');
        const qtyInput = ChangedItem.value;
            if (variantId) {
                updateBBitems(variantId, qtyInput);
            }
    }
});

//call change or add bb item
function updateBBitems(id,qt)
{

    const addedItemsContainer = document.querySelector('#bbt-added-items');

    if (!addedItemsContainer) return;
    // Check if item already exists with data-bb-added-id
    let existingItem = addedItemsContainer.querySelector(`[data-bb-added-id="${id}"]`);

    if (existingItem) {

        // Update quantity if item exists
        const qtyElement = existingItem.querySelector('.bbsr-qty span');
        if (qtyElement) {
            qtyElement.textContent = qt;
        }
        existingItem.setAttribute('data-bb-added-qty', qt);

        if (qt == 0) {
            if (existingItem) {
                updateBundleCardQty();
                existingItem.remove();
            }
        }


    } else {
        // Check for element with data-bbvariant-id
        const addedIdElement = document.querySelector(`[data-bbvariant-id="${id}"] .zpro-bundle-summary-wraps`);

            if (addedIdElement) {
                    addedItemsContainer.insertAdjacentHTML('beforeend', addedIdElement.innerHTML);
                    updateBundleCardQty()
            }

    }
    calculateBBitems();
}

let bbdiscountCode = null;
function calculateBBitems()
{

    // Get all elements with data-bb-added-id inside #bbt-added-items
    const addedItems = document.querySelectorAll('#bbt-added-items [data-bb-added-id]');

    // .bbt-boxes container and .bbt-boxes nodeList
    const bbtBoxesWrap = document.querySelector('.bbt-boxes');
    let bbtBoxes = bbtBoxesWrap ? bbtBoxesWrap.querySelectorAll('.bbt-box') : [];

    // First, clear ALL images from all boxes at the start
    if (bbtBoxesWrap) {
        for (let i = 0; i < bbtBoxes.length; i++) {
            const boxImgWrap = bbtBoxes[i].querySelector('.bbtbimg');
            if (boxImgWrap) {
                boxImgWrap.innerHTML = '';
            }
        }
    }

    // Loop through each added item
    let itemCount = 0;
    for (let i = 0; i < addedItems.length; i++) {
        const item = addedItems[i];
        if (!item) continue;
        const variantId = item.getAttribute('data-bb-added-id');
        const quantity = Number(item.getAttribute('data-bb-added-qty'));
        if (!variantId || quantity <= 0) continue;

        // INSERT_YOUR_CODE

        // Get image url from .bbsr-img img
        const itemImg = item.querySelector('.bbsr-img img');
        const imgSrc = itemImg ? itemImg.getAttribute('src') : '';

        // Update boxes NodeList after potential DOM changes
        bbtBoxes = bbtBoxesWrap ? bbtBoxesWrap.querySelectorAll('.bbt-box') : [];

        // For each unit of this item's quantity, set images in .bbt-box
        for (let q = 0; q < quantity; q++) {
            let targetIndex = itemCount + q;
            // If box doesn't exist at target index, duplicate the first .bbt-box and append it with 'duplicated' class
            while (bbtBoxesWrap && !bbtBoxes[targetIndex]) {
                if (bbtBoxes.length > 0) {
                    const firstBox = bbtBoxes[bbtBoxes.length - 1];
                    if (!firstBox) break;
                    const clone = firstBox.cloneNode(true);
                    if (clone instanceof HTMLElement) {
                        clone.classList.add('duplicated');
                    }
                    bbtBoxesWrap.appendChild(clone);
                    // update NodeList after DOM mutation
                    bbtBoxes = bbtBoxesWrap.querySelectorAll('.bbt-box');
                } else {
                    break; // No box to duplicate
                }
            }
            const targetBox = bbtBoxes[targetIndex];
            if (targetBox) {
                const boxImgWrap = targetBox.querySelector('.bbtbimg');
                if (boxImgWrap && imgSrc) {
                    boxImgWrap.innerHTML = '';
                    const newImg = document.createElement('img');
                    newImg.src = imgSrc;
                    boxImgWrap.appendChild(newImg);
                }
            }
        }

        itemCount += quantity;
    }

    // After processing all items, remove excess duplicated boxes
    if (bbtBoxesWrap) {
        bbtBoxes = bbtBoxesWrap.querySelectorAll('.bbt-box');
        const requiredCount = itemCount;
        let currentCount = bbtBoxes.length;
        if (currentCount > requiredCount) {
            // Only remove .duplicated boxes and only from the end of the list
            const boxesArr = Array.from(bbtBoxes);
            let toRemove = currentCount - requiredCount;
            for (let i = boxesArr.length - 1; i >= 0 && toRemove > 0; i--) {
                const box = boxesArr[i];
                if (box && box.classList.contains('duplicated')) {
                    if (box.parentNode) {
                        box.parentNode.removeChild(box);
                        toRemove--;
                    }
                }
            }
        }
    }

    // Refresh boxes NodeList after all changes
    bbtBoxes = bbtBoxesWrap ? bbtBoxesWrap.querySelectorAll('.bbt-box') : [];

    // Discount / code: match tier by items_required (not by slot index, which breaks with duplicated boxes)
    let discountValue = null;
    bbdiscountCode = null;
    if (bbtBoxesWrap && itemCount > 0) {
        const targetBox = getQualifyingBundleTierBox(itemCount);
        if (targetBox) {
            discountValue = Number(targetBox.getAttribute('data-bb-discount')) || 0;
            bbdiscountCode = bbNormalizeDiscountCode(targetBox.getAttribute('data-bb-d-code'));
        }
    }

    console.log('itemCount:', itemCount, 'discountValue:', discountValue,bbdiscountCode);

    // Find all original (non-duplicated) .bbt-box elements that have been passed and get their .bbtb-txt text
    const specialTexts = [];
    if (bbtBoxesWrap && itemCount > 0) {
        const allBoxes = bbtBoxesWrap.querySelectorAll('.bbt-box');
        // Get all non-duplicated boxes up to the current itemCount
        const maxIndex = Math.min(itemCount, allBoxes.length);
        for (let i = 0; i < maxIndex; i++) {
            const box = allBoxes[i];
            if (!box) continue;
            // Check if it's not duplicated
            if (!box.classList.contains('duplicated')) {
                const txtElement = box.querySelector('.bbtb-txt');
                if (txtElement) {
                    const txt = txtElement.textContent.trim();
                    if (txt) {
                        specialTexts.push(txt);
                    }
                }
            }
        }
    }

    // Update .bbt-labels with discount value and all special texts (update all matching elements)
    const labelsElements = document.querySelectorAll('.bbt-labels');
    let labelsHTML = '';
    if (discountValue && discountValue > 0) {
        labelsHTML = `<span>SAVE ${discountValue}%</span>`;
        // Add all special texts as separate spans
        for (let i = 0; i < specialTexts.length; i++) {
            labelsHTML += `<span>${specialTexts[i]}</span>`;
        }
    }
    for (let i = 0; i < labelsElements.length; i++) {
        const el = labelsElements[i];
        if (el) {
            el.innerHTML = labelsHTML;
        }
    }

     // Get all .zpro-bundle-summary-row elements inside #bbt-added-items
     const summaryRows = document.querySelectorAll('#bbt-added-items .zpro-bundle-summary-row');

     // Initialize totals
     let totalBeforeDiscount = 0;
     let totalDiscounted = 0;
     const currencySymbol = window.currencySymbol || '';

     // Loop through each row
     for (let i = 0; i < summaryRows.length; i++) {
         const row = summaryRows[i];
         if (!row) continue;

         // Get price and quantity from data attributes
         const price = Number(row.getAttribute('data-bb-price')) || 0;
         const quantity = Number(row.getAttribute('data-bb-added-qty')) || 0;

         // Calculate original total: (price * quantity) / 100
         const originalTotal = (price * quantity) / 100;

         // Calculate discounted total if discountValue exists
         let discountedTotal = originalTotal;
         if (discountValue && discountValue > 0) {
             const discountSingle =(Math.ceil(price * (1 - discountValue / 100)) / 100).toFixed(2);
             discountedTotal = discountSingle * quantity;
         }

         // Add to totals
         totalBeforeDiscount += originalTotal;
         totalDiscounted += discountedTotal;

        // Format to 2 decimal places
        const formattedOriginal = originalTotal.toFixed(2);
        // Use ceiling (round up) for discounted total, then format to 2 decimal places
        const formattedDiscounted = (Math.ceil(discountedTotal * 100) / 100).toFixed(2);

        // Find .bbsr-price-org and update with discounted price
        const priceElement = row.querySelector('.bbsr-price-org');
        if (priceElement) {
            priceElement.textContent = currencySymbol + formattedDiscounted;
        }

        // Find .bbsr-price-comp and update with original price
        const comparePriceElement = row.querySelector('.bbsr-price-comp');
        if (comparePriceElement) {
            if (discountValue && discountValue > 0 && discountedTotal < originalTotal) {
                comparePriceElement.textContent = currencySymbol + formattedOriginal;
            } else {
                comparePriceElement.textContent = '';
            }
        }
     }

     // Update total compare price (before discount) - update all matching elements
     // Only show compare price if discounted price is different from original price
     const totalCompareElements = document.querySelectorAll('.data-bb-total-compare');
     const comparePriceValue = (totalBeforeDiscount > 0 && totalBeforeDiscount !== totalDiscounted) ? totalBeforeDiscount.toFixed(2) : '';
     const comparePriceText = comparePriceValue ? currencySymbol + comparePriceValue : '';
     for (let i = 0; i < totalCompareElements.length; i++) {
         const el = totalCompareElements[i];
         if (el) {
             el.textContent = comparePriceText;
         }
     }

     // Update total price (discounted) - update all matching elements
     const totalPriceElements = document.querySelectorAll('.data-bb-total-price');
     const totalPriceText = currencySymbol + totalDiscounted.toFixed(2);
     for (let i = 0; i < totalPriceElements.length; i++) {
         const el = totalPriceElements[i];
         if (el) {
             el.textContent = totalPriceText;
         }
     }

     // Update .bbt-title-price - update all matching elements
     const titlePriceElements = document.querySelectorAll('.bbt-title-price');
     for (let i = 0; i < titlePriceElements.length; i++) {
         const titlePriceEl = titlePriceElements[i];
         if (!titlePriceEl) continue;
         // Update the price span inside .bbt-title-price
         const priceSpan = titlePriceEl.querySelector('.data-bb-total-price');
         if (priceSpan) {
             priceSpan.textContent = totalPriceText;
         }
         // Update the compare price (strikethrough) inside .bbt-title-price
         const compareSpan = titlePriceEl.querySelector('.data-bb-total-compare');
         if (compareSpan) {
             compareSpan.textContent = comparePriceText;
         }
     }

     // Update checkout button state based on minActivateItems
     const checkoutButtons = document.querySelectorAll('.bb-checkout-btn');
     const minActivateItems = window.minActivateItems || 0;
     if (itemCount >= minActivateItems) {
         // Remove inactive class if item count meets minimum requirement
         checkoutButtons.forEach(btn => {
             btn.classList.remove('inactive');
         });
     } else {
         // Add inactive class if item count is below minimum requirement
         checkoutButtons.forEach(btn => {
             btn.classList.add('inactive');
         });
     }
}



function fetchBundleCollection(url)
{
    const mainurl = url.toString().split("?")[0];
    const requestUrl = `${mainurl}?section_id=zpro-bundle-collection-s`;

    // Fetch the content
    fetch(requestUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            // Create a temporary DOM element to parse the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Extract and insert content for the '.collection' class
            const collectionContent = tempDiv.querySelector('.bb-collection-ajax');
            if (collectionContent) {
                const collectionWrap = document.querySelector('.bb-collection-ajax');
                if (collectionWrap) {
                    collectionWrap.innerHTML = collectionContent.innerHTML;
                }
            }


            initBundleSliders();
            updateBundleCardQty();
            window.scrollTo(0, 0);

        })
        .catch(error => {
            console.error('Error loading content:', error);
        });
}





